import { Box, CircularProgress, Typography } from '@mui/material';

export interface LoadingStateProps {
  /** Optional label shown beneath the spinner. */
  label?: string;
  /** Reserve a comfortable minimum height (useful for page-level loading). */
  fullHeight?: boolean;
}

/** Generic, business-agnostic loading indicator. */
export function LoadingState({ label = 'Loading…', fullHeight = true }: LoadingStateProps) {
  return (
    <Box
      role="status"
      aria-live="polite"
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 2,
        py: 6,
        minHeight: fullHeight ? 240 : 'auto',
        color: 'text.secondary',
      }}
    >
      <CircularProgress size={36} thickness={4} />
      {label ? <Typography variant="body2">{label}</Typography> : null}
    </Box>
  );
}
